import { type PermissionRouteData, PermissionRoute } from '@exam-management/permission-route';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';

export default function QBankStructureRouteController() {
  const { structureId } = useParams('/qbank-structures/:structureId');
  const defaultRoutes: PermissionRouteData[] = [
    {
      path: '/qbank-structures/:structureId/dashboard',
      requiredPermission: [APP_PERMISSIONS.QBANK.DASHBOARD.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/structure',
      requiredPermission: [APP_PERMISSIONS.QBANK.STRUCTURE.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/qcontents',
      requiredPermission: [APP_PERMISSIONS.QBANK.QUESTION.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/los',
      requiredPermission: [APP_PERMISSIONS.QBANK.LOS.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/setting',
      requiredPermission: [APP_PERMISSIONS.QBANK.SETTING.VIEW],
      params: {
        structureId,
      },
    },
    {
      path: '/qbank-structures/:structureId/activity-log',
      requiredPermission: [APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW],
      params: {
        structureId,
      },
    },
  ];

  return <PermissionRoute routes={defaultRoutes} />;
}
